import React, {useState} from 'react';
import { makeStyles } from '@mui/styles';
import blue from '@mui/material/colors/blue';
import { Redirect } from "react-router-dom";

const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
});

function SubmissionDialog(props) {
    const classes = useStyles();
    const { type, open, onClose } = props;
    const [ redirectStatus, setRedirectStatus] = useState(true);

    const handleClose = (value) => {
        onClose(value);
    };

    const handleClick = (value) => {
        setRedirectStatus(true)
    };

    if(redirectStatus){
        if(type==="Experiments") {
            return <Redirect to={{pathname:'/experimentsubmitted', 
                                  title: "Experiments submitted",
                                  tableContents:props.tableContents, 
                                  filename:props.filename, 
                                  nextPage:'/selectexperiments',
                                  nextPageLabel:'GO TO SUBMIT FILE(s)',
                                  tooltip: "Complete your submission uploading files metadata for your experiments"}}/>;
        } else {
            return <Redirect to={{pathname:'/filesubmitted',
                                  title: "File metadata submitted",
                                  tableContents:props.tableContents, 
                                  filename:props.filename, 
                                  nextPage:'/submissionexperimentclose',
                                  nextPageLabel:'GO TO SUBMISSION EXPERIMENT CLOSE',
                                  tooltip: "Close the experiment file metadata submission."}}/>
        }
    }
}

export default SubmissionDialog;
